export default __webpack_public_path__ + "static/media/Edit_E.c7125cf2.svg";